/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';
import type { UsersDTO } from './UsersDTO';
import {
    UsersDTOFromJSON,
    UsersDTOFromJSONTyped,
    UsersDTOToJSON,
    UsersDTOToJSONTyped,
} from './UsersDTO';

/**
 * 
 * @export
 * @interface PagedModelUsersDTO
 */
export interface PagedModelUsersDTO  {
    /**
     * 
     * @type {Array<UsersDTO>}
     * @memberof PagedModelUsersDTO
     */
    content?: Array<UsersDTO>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelUsersDTO
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelUsersDTO interface.
 */
export function instanceOfPagedModelUsersDTO(value: object): value is PagedModelUsersDTO {
    return true;
}

export function PagedModelUsersDTOFromJSON(json: any): PagedModelUsersDTO {
    return PagedModelUsersDTOFromJSONTyped(json, false);
}

export function PagedModelUsersDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelUsersDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(UsersDTOFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelUsersDTOToJSON(json: any): PagedModelUsersDTO {
    return PagedModelUsersDTOToJSONTyped(json, false);
}

export function PagedModelUsersDTOToJSONTyped(value?: PagedModelUsersDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(UsersDTOToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


